// extracted by mini-css-extract-plugin
export var caretAnchor = "_vf-0";
export var dropdownContent = "_vf-1";